export const enum AgentType {
    Bot = 'BOT',
    Operator = 'OPERATOR',
    Manager = 'MANAGER',
}
